import { useContext } from 'react'
import { CurrentUserContext } from '~/context/currentUser'

export default function useCurrentUser() {
  return useContext(CurrentUserContext)
}
